module.exports = __webpack_public_path__ + "img/icon_tw.bee4c299.svg";